export const parseArquivoAdditions = (additions) => {
  if (additions == null || additions === '') return null;
  if (typeof additions === 'object') return additions;
  if (typeof additions !== 'string') return null;
  try {
    const parsed = JSON.parse(additions);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

export const formatArquivoPrecisaoMetros = (value, fractionDigits = 2) => {
  if (value == null || value === '') return null;
  const num = Number(value);
  if (Number.isNaN(num)) return `± ${value} m`;
  return `± ${num.toFixed(fractionDigits)} m`;
};

export const formatEvidenciaGpsCaption = (additions) => {
  const data = parseArquivoAdditions(additions);
  if (!data) return null;

  const parts = [];
  const endereco = data.enderecoShow
    ? String(data.enderecoShow).replace(/\n/g, ', ')
    : data.endereco;
  if (endereco) parts.push(endereco);
  if (data.latitude != null && data.longitude != null) {
    parts.push(`${data.latitude} / ${data.longitude}`);
  }
  const precisaoLabel = formatArquivoPrecisaoMetros(data.precisao);
  if (precisaoLabel) parts.push(`precisão ${precisaoLabel}`);

  return parts.length > 0 ? parts.join(' · ') : null;
};

export const isArquivoCarimbada = (additions) => {
  const data = parseArquivoAdditions(additions);
  return data?.carimbada === true || data?.carimbada === 'true';
};

export const getArquivoEnderecoLabel = (additions) => {
  const data = parseArquivoAdditions(additions);
  if (!data) return null;
  const endereco = data.enderecoShow
    ? String(data.enderecoShow).replace(/\n/g, ', ')
    : data.endereco;
  return endereco ? String(endereco) : null;
};

export const getArquivoGeoCoords = (additions) => {
  const data = parseArquivoAdditions(additions);
  if (!data || data.latitude == null || data.longitude == null) return null;
  const lat = parseFloat(data.latitude);
  const lng = parseFloat(data.longitude);
  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
  return { lat, lng };
};

export const mapsUrlFromArquivoAdditions = (additions) => {
  const coords = getArquivoGeoCoords(additions);
  if (coords) {
    return `https://www.google.com/maps?q=${encodeURIComponent(`${coords.lat},${coords.lng}`)}`;
  }
  const endereco = getArquivoEnderecoLabel(additions);
  if (endereco) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`;
  }
  return null;
};

export const geoPointFromArquivoAdditions = (additions, title = 'Local da foto') => {
  const coords = getArquivoGeoCoords(additions);
  if (!coords) return null;
  return {
    id: 'foto',
    lat: coords.lat,
    lng: coords.lng,
    title,
    endereco: getArquivoEnderecoLabel(additions),
  };
};
